<template>
  <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
    <LoanTable
      :loading="isLoading"
      :rows="loanList"
      :columns="columns"
      :line-numbers="true"
      :sort="sort"
      :page="page"
      :per-page="perPage"
      :page-size="pageSize"
      :total-page="totalPage"
      :total-records="totalRecords"
      @delete="confirmRemoval"
      @onFilter="onFilter"
      @onPageChange="onPageChange"
      @onPerPageChange="onPerPageChange"
      @onSortChange="onSortChange"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LOAN_LIST_REQUEST } from '@/store/actions/loan';
import LoanTable from '@/components/loan/LoanTable';
import dataListMixin from '@/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],

  props: {
    officer: Object,
  },

  components: {
    LoanTable,
  },

  data() {
    return {
      storeActionListRequest: LOAN_LIST_REQUEST,
      columns: [
        {
          label: this.$t('text.loanNumber'),
          field: 'id',
          filterable: true,
        },
        {
          label: this.$t('text.firstName'),
          field: 'firstName',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('text.customer'),
          field: 'user',
        },
        {
          label: this.$t('text.registrationNumber'),
          field: 'registrationNumber',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('table.phone'),
          field: 'phone',
          filterable: true,
        },
        {
          label: this.$t('text.loanAmount'),
          field: 'amount',
        },
        {
          label: this.$t('text.status'),
          field: 'status',
        },
        {
          label: this.$t('text.numberOfBankAccount'),
          field: 'bankAccount',
          filterable: true,
        },
        {
          label: this.$t('text.loanFirstOfficer'),
          field: 'firstOfficer',
        },
        {
          label: this.$t('text.loanOfficer'),
          field: 'officer',
        },
        {
          label: this.$t('table.action'),
          field: 'action',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['loanList', 'loanStatus', 'loanMeta']),
    isLoading() {
      return this.loanStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[status]`] = 'ACTIVE';
      data.filters[`filter[officerId]`] = this.officer.id;
    },

    setPaginationValues() {
      this.totalRecords = this.loanMeta ? this.loanMeta.total : 1;
      this.page = this.loanMeta.currentPage;
      this.totalPage = this.loanMeta.lastPage;
    },
  },
};
</script>
